import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, PageOptions } from "cw-backend";
import { BehaviorSubject, Observable } from "rxjs";
import { SnackBarService } from "../../../../cw-utils/snackbar.service";
import { Attachment } from "../../../models/operational/medical/attachment/attachment";

@Injectable()
export class AttachmentProvider implements Resolve<any> {
    onDataChanged: BehaviorSubject<any>;
    attachment: Attachment;

    constructor(
        public gw: ApiGateway,
        private location: Location,
        private snackBar: SnackBarService,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    static pageAttachmentType = new EventEmitter<any>();

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        throw new Error("Method not implemented.");
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("attachment/").subscribe((res: HttpResponse<any>) => {
                resolve(res);
            }, reject);
        });
    }

    getById(id: number): Observable<HttpResponse<Attachment>> {
        if (!id) {
            return null;
        }
        return this.gw.get("attachment/:id", { id: id });
    }

    insert(attachment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("attachment/", attachment)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    insertStorage(attachment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("attachment/storage/", attachment)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    edit(attachment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("attachment/", attachment)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    delete(attachment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .delete("attachment/" + attachment.id)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    deleteStorage(attachment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .delete("attachment/storage/" + attachment.id)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    getPageByID(pageOptions: PageOptions, idPatient): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`attachment/search/${idPatient}`, pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPageByTypeAndPatientId(
        pageOptions: PageOptions,
        idPatient,
        type,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`attachment/search/${idPatient}/${type}`, pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPageByTypeAndPatientIdAndDocument(
        pageOptions: PageOptions,
        idPatient,
        type,
        documentId,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    `attachment/search/${idPatient}/${type}/${documentId}`,
                    pageOptions,
                )
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPageByTypeAndPatientIdAndDocumentStorage(
        pageOptions: PageOptions,
        idPatient,
        type,
        documentId,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    `attachment/search/storage/${idPatient}/${type}/${documentId}`,
                    pageOptions,
                )
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPageByTypeAndPatientIdStorage(
        pageOptions: PageOptions,
        idPatient,
        type,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    `attachment/search/storage/${idPatient}/${type}`,
                    pageOptions,
                )
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    insertDescription(description, attachamentId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`attachment/description/${attachamentId}`, description)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                    this.snackBar.successMessage(
                        "Dados cadastrados com sucesso!",
                    );
                }, reject);
        });
    }

    checkedCapture(checked, attachamentId): Promise<any> {
        let checkedPost = {
            checked: checked,
        };
        return new Promise((resolve, reject) => {
            this.gw
                .post(`attachment/checked/${attachamentId}`, checkedPost)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                    this.snackBar.successMessage(
                        "Dados cadastrados com sucesso!",
                    );
                }, reject);
        });
    }
}
